<template>
  <div
    :class="$style.icon"
    class="mt-icon mt-icon-trash"
  />
</template>
<script type="text/ecmascript-6">
export default {
  name: 'TrashIcon'
}
</script>

<style lang="scss" module>
@import "mpl-css/lib/assets/global/variables/colors";
@import "mpl-css/lib/assets/global/functions/index";
@import "mpl-css/lib/assets/global/icons/icons-colors";
$trash-fill: encodeHexColor(map-get($colors, 'new-blue'));
@import "mpl-css/lib/assets/global/icons/icons-svg";
$trashIcon: map-get($icons, 'trash');
.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  &:before {
    position: relative;
    background-image: url($trashIcon);
    background-size: 80% 80%;
  }
}
</style>
